const parkPlacards = [
  ['Permanent Parking Placard (No Fee)', 'Permanent Parking Placard|0'],
  ['Additional 2nd Permanent Parking Placard (No Fee)', 'Additional 2nd Permanent Parking Placard|0'],
  ['Replacement Permanent Parking Placard (No Fee)', 'Replacement Permanent Parking Placard|0'],
  ['Duplicate Registration for Permanent Parking Placard (No Fee)', 'Duplicate Registration for Permanent Parking Placard|0'],
  ['Temporary Parking Placard', 'Temporary Parking Placard|15.00'],
  ['Subsequent Temporary Parking Placard (issued within 12 months of prior fee payment) (No Fee)', 'Subsequent Temporary Parking Placard|0'],
  ['Duplicate Registration for Temporary Parking Placard', 'Duplicate Registration for Temporary Parking Placard|1.50'],
  ['Lost-in-Transit Permanent or Temporary Parking Placard (No Fee)', 'Lost-in-Transit Permanent or Temporary Parking Placard|0'],
];

export default parkPlacards;



// WEBPACK FOOTER //
// ./src/modules/data/park-placards.js